// extracted by mini-css-extract-plugin
module.exports = {"list":"PrimaryNav_list__A7NjG","item":"PrimaryNav_item__xnFxd","link":"PrimaryNav_link__eXXyr","slide-down":"PrimaryNav_slide-down__FcdYE","slide-up":"PrimaryNav_slide-up___Yvo5"};